import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { getIndividualPointsStatement, downloadPoints } from '../../actions/points-statement';
import IndividualRewardsStatementList from './individual-rewards-statement-list';
import Filter from './filter';

class IndividualRewardsStatement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      filters: {}
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getIndividualPointsStatement('individual'));
  }

  handlePageChange = (page, size) => {
    this.setState({ pageNumber: page }, this.handleSearch);
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const { pageNumber, filters } = this.state;
    
    dispatch(getIndividualPointsStatement('individual', pageNumber, filters));
  };

  applyFilters = (filters) => {
    const { dispatch } = this.props;
    const { pageNumber } = this.state;

    dispatch(getIndividualPointsStatement('individual', pageNumber, filters));
    this.setState({ filters });
  };

  download = () => {
    downloadPoints('individual');
    return;
  };

  render() {
    const { stores, points_statements, fetching, fetched, pagination } = this.props;
    const { pageNumber } = this.state;

    return (
      <div>
        <Row>
          <Col md={6} className="filter-transactions">
            <Filter
              stores={stores}
              applyFilters={this.applyFilters}
              download={this.download}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="point-transactions-table">
            <IndividualRewardsStatementList
              points_statement={points_statements}
              fetching={fetching}
              fetched={fetched}
              pagination={pagination}
              onPageChange={this.handlePageChange}
              currentPage={pageNumber}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stores: state.points_statement.outlets,
    points_statements: state.points_statement.personalList,
    pagination: state.points_statement.personalListPaging,
    fetching: state.points_statement.fetching,
    fetched: state.points_statement.fetched,
    userGroup: state.viewConfig.profile.attributes['user-group']
  };
};

export default connect(mapStateToProps)(IndividualRewardsStatement);



// WEBPACK FOOTER //
// ./src/components/points-statement/individual-rewards-statement.jsx